import { Label } from "@radix-ui/react-label";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ConfigurationField } from "../../types";

import { Button } from "@/components/ui/v2/button";
import { Input } from "@/components/ui/v2/input";

export function PasswordField({
  field,
  disabled,
}: {
  field: Extract<ConfigurationField, { type: "password" }>;
  disabled?: boolean;
}) {
  const { register } = useFormContext();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const placeholder = field.placeholder?.startsWith("integrations.")
    ? t(field.placeholder)
    : field.placeholder;

  return (
    <div className="space-y-2">
      <Label htmlFor={field.key} className="text-base">
        {t(field.label)}
        {field.required && <span className="text-destructive ml-1">*</span>}
      </Label>
      <div className="relative">
        <Input
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          disabled={disabled}
          {...register(field.key)}
        />
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowPassword(!showPassword);
          }}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
          tabIndex={-1}
        >
          {showPassword ? (
            <EyeOff className="h-4 w-4" />
          ) : (
            <Eye className="h-4 w-4" />
          )}
        </Button>
      </div>
    </div>
  );
}
